import { ChangeDetectionStrategy, Component } from '@angular/core';
import { catchError, map, of, switchMap } from 'rxjs';
import { SettingsApiService } from '../../services/settings-api.service';
import { createEnhancedDataServicesEntityConfigList } from '../../utils';
import {
  EnhancedDataServicesApiKeyEntity,
  EnhancedDataServicesEntityData,
} from '../../types';
import { DownloadService } from '@firebird-web/shared-services';

@Component({
  selector: 'firebird-web-enhanced-data-services',
  templateUrl: './enhanced-data-services.component.html',
  styleUrls: ['./enhanced-data-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SettingsApiService, DownloadService],
  standalone: false,
})
export class EnhancedDataServicesComponent {
  public entityConfigList$ = this.settingsApiService
    .getEnhancedDataServicesApiKeys()
    .pipe(
      map((apiKeys) => createEnhancedDataServicesEntityConfigList(apiKeys)),
      switchMap((entityConfigList) =>
        // fetches dynamic assets (e.g., api documentation) otherwises uses local asset as a fallback
        this.downloadService.downloadApiDocumentation().pipe(
          catchError(() =>
            of('/assets/documentation/WSI Trader API Documentation.pdf')
          ),
          map((url) => {
            return entityConfigList.map((entityConfig) => {
              if (entityConfig.entity !== 'trader') return entityConfig;
              return {
                ...entityConfig,
                documentationList: entityConfig.documentationList.map((doc) =>
                  doc.labelKey === 'enhancedDataServicesTraderDataDocumentation'
                    ? { ...doc, link: url }
                    : doc
                ),
              };
            });
          })
        )
      )
    );

  constructor(
    private readonly settingsApiService: SettingsApiService,
    private readonly downloadService: DownloadService
  ) {}

  public trackByEntity(
    _: number,
    { entity }: EnhancedDataServicesEntityData
  ): EnhancedDataServicesApiKeyEntity {
    return entity;
  }
}
